import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import cn from 'classnames';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import { AggregateRatingContainer } from 'app/components/shared/AggregateRating';
import { UserRatingDropdownContainer } from 'app/components/shared/UserRatingDropdown';
import BibJacket from 'app/components/bibs/shared/BibJacket';
import BibTitle from 'app/components/bibs/shared/BibTitle';
import BibAuthors from 'app/components/bibs/shared/BibAuthors';
import EditionAndLanguageContainer from 'app/components/bibs/shared/EditionAndLanguage';
import BibExcerptContainer from 'app/components/bibs/BibPage/Transact/BibExcerpt/BibExcerptContainer';
import ConnectedLibraryPanelContainer from 'app/components/bibs/shared/ConnectedLibraryPanel/ConnectedLibraryPanelContainer';
import ExternalSearchPanelContainer from 'app/components/bibs/shared/ExternalSearchPanel';
import TransactPanelContainer from './TransactPanel/TransactPanelContainer';
import FormatChooserContainer from './FormatChooser/FormatChooserContainer';
import BibDescription from './BibDescription';

import './Transact.scss';

export function Transact({ catalogBib, trackAuthorClick }) {
  const { mobileApp } = useContext(Context);
  const format = catalogBib.getIn(['brief', 'format']);
  const cover = catalogBib.getIn(['brief', 'coverImage']);
  const metadataId = catalogBib.get('metadataId');
  const classNames = cn('cp-bib-transact container', { 'bib-transact--mobile-app': mobileApp });

  return (
    <section className={classNames}>
      <div className="row">
        <div className="col-md-2 col-lg-3">
          <BibJacket format={format} cover={cover} metadataId={metadataId} />
          <div className="cp-bib-excerpt-desktop">
            <BibExcerptContainer />
          </div>
        </div>
        <div className="col-md-5 col-lg-5 col-xl-6 main-info">
          <BibTitle catalogBib={catalogBib} secondaryClassName="secondary-title" />
          <BibAuthors catalogBib={catalogBib} trackClick={trackAuthorClick} />
          <EditionAndLanguageContainer />
          <div className="rating-info">
            <AggregateRatingContainer metadataId={metadataId} />
            <UserRatingDropdownContainer metadataId={metadataId} />
          </div>
          <FormatChooserContainer />
          <BibDescription
            descriptionHtml={catalogBib.getIn(['brief', 'description']) ?? ''}
            uniqueIdPrefix="BibDescrition"
          />
          <div className="cp-bib-excerpt-mobile">
            <BibExcerptContainer />
          </div>
        </div>
        <div className="col-md-5 col-lg-4 col-xl-3 transact-panel">
          <TransactPanelContainer />
          <ConnectedLibraryPanelContainer />
          <ExternalSearchPanelContainer />
        </div>
      </div>
    </section>
  );
}

Transact.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  trackAuthorClick: PropTypes.func.isRequired
};

export default Transact;
